import { useQuery } from "@tanstack/react-query";
import { orpc } from "@/frontend/orpc-client";

export function useInvitationQuery(invitationId: string) {
  return useQuery({
    ...orpc.admin.getInvitation.queryOptions({ input: { invitationId } }),
    enabled: !!invitationId,
    retry: false,
  });
}
